import { default as ImageContainer } from './background-image';

export default ImageContainer;
